export const AUCKLAND_BBOX = "174.15698,-37.292765,175.292505,-36.116668";
export const DEFAULT_DEBOUNCE_PERIOD_MS = 300;
export const DEFAULT_FETCH_TIMEOUT_MS = 60000;

export const DEFAULT_GTFS_STATION_RESULT_LIMIT = 10;
export const DEFAULT_GTFS_STOP_RESULT_LIMIT = 5;
export const DEFAULT_GTFS_TOTAL_RESULT_LIMIT = 10;
export const DEFAULT_MAPBOX_RESULT_LIMIT = 10;
